{
  "newActivityNotification": "Thông báo hoạt động mới",
  "title": {
    "SELL_ORDER_PAIRED": "Lệnh đã ghép cặp",
    "BUY_ORDER_PAIRED": "Lệnh đã ghép cặp",
    "BUY_ORDER_UPLOAD_PAYMENT_PROOF": "Lệnh đã thanh toán",
    "SELL_ORDER_COMFIRMED_PAYMENT_PROOF": "Lệnh đã giải phóng token",
    "BUY_ORDER_CANCELED": "Lệnh đã hủy",
    "BUY_ORDER_REQUEST_APPEAL_FROM_SELLER": "Lệnh đã được khiếu nại",
    "BUY_ORDER_REQUEST_APPEAL_FROM_BUYER": "Lệnh đã được khiếu nại",
    "SELL_ORDER_CHANGED_AMOUNT": "Lệnh có yêu cầu chỉnh sửa",
    "BUY_ORDER_AGREED_CHANGE_AMOUNT": "Chỉnh sửa lệnh thành công",
    "BUY_ORDER_DISAGREED_CHANGE_AMOUNT": "Chỉnh sửa lệnh thất bại",
    "SELL_ORDER_REQUEST_PAIR_CANCELED": "Có yêu cầu hủy lệnh",
    "ADMIN_APPROVED_PAIR_CANCELED": "Đã hủy lệnh thành công",
    "ADMIN_REJECTED_PAIR_CANCELED": "Không thể hủy lệnh",
    "ADMIN_FORCE_CANCELED_PAIR": "Bộ phận hỗ trợ đã hủy lệnh",
    "ADMIN_FORCE_CANCELED_SELL_ORDER": "Bộ phận hỗ trợ đã hủy lệnh",
    "ADMIN_FORCE_CANCELED_BUY_ORDER": "Bộ phận hỗ trợ đã hủy lệnh",
    "ADMIN_FORCE_CONFIRMED": "Bộ phận hỗ trợ đã giải phóng token",
    "ADMIN_FORCE_CHANGED_AMOUNT": "Bộ phận hỗ trợ đã chỉnh sửa và giải phóng token",
    "USER_TRANSFERRED_PAYMENT_GATE_WAY": "Thông báo thanh toán",
    "USER_RECEIVED_CURRENCY": "Thông báo nhận token",
    "USER_WITHDRAWAL_CURRENCY": "Thông báo rút token",
    "USER_DEPOSIT_CURRENCY": "Thông báo thanh toán",
    "USER_EXCHANGE_IN": "Thông báo quy đổi",
    "USER_EXCHANGE_OUT": "Thông báo quy đổi",
    "USER_RECEIVED_EXCHANGE": "Thông báo quy đổi",
    "USER_RECEIVED_PAYOUT": "Thông báo nhận token",
    "ADMIN_BUY_ORDER_CANCELED": "Đã hủy lệnh thành công",
    "BUYER_BUY_ORDER_FORCE_CANCELED": "Lệnh đã hủy",
    "ADMIN_REJECT_KYC": "Xác minh danh tính không đạt",
    "ADMIN_APPROVE_KYC": "Xác minh danh tính đã đạt",
    "BONUS_ACTIVITY_CREATED": "{{title}}"
  },
  "description": {
    "SELL_ORDER_PAIRED": "Lệnh {{orderId}} có ghép cặp mới. Lệnh đang thanh toán là {{subOrderId}}; chúng tôi sẽ thông báo người mua thanh toán trong {{payTime}} phút.",
    "BUY_ORDER_PAIRED": "Lệnh {{orderId}} đã ghép cặp. Hãy chuyển tiền theo thông tin nhận tiền của người bán trong {{payTime}} phút.",
    "BUY_ORDER_UPLOAD_PAYMENT_PROOF": "Người mua đã thanh toán lệnh {{subOrderId}}. Hãy xác nhận đã nhận tiền và giải phóng token trong 10 phút.",
    "SELL_ORDER_COMFIRMED_PAYMENT_PROOF": "Người bán đã giải phóng token cho lệnh {{orderId}}.",
    "BUY_ORDER_CANCELED": "Người mua đã hủy lệnh {{subOrderId}}.",
    "BUY_ORDER_REQUEST_APPEAL_FROM_SELLER": "Người bán đã khiếu nại lệnh {{orderId}}. Hãy liên hệ bộ phận hỗ trợ.",
    "BUY_ORDER_REQUEST_APPEAL_FROM_BUYER": "Người mua đã khiếu nại lệnh {{subOrderId}}. Hãy liên hệ bộ phận hỗ trợ.",
    "SELL_ORDER_CHANGED_AMOUNT": "Người bán đã yêu cầu chỉnh sửa số tiền cho lệnh {{orderId}}. Hãy phản hồi yêu cầu chỉnh sửa.",
    "BUY_ORDER_AGREED_CHANGE_AMOUNT": "Người mua đã chấp nhận chỉnh sửa cho lệnh {{subOrderId}}.",
    "BUY_ORDER_DISAGREED_CHANGE_AMOUNT": "Người mua đã từ chối chỉnh sửa cho lệnh {{subOrderId}}. Lệnh đã trở về trạng thái chờ giải phóng token, hãy xem chi tiết.",
    "SELL_ORDER_REQUEST_PAIR_CANCELED": "Người bán đã yêu cầu hủy lệnh {{id}}. Vui lòng chờ bộ phận hỗ trợ phản hồi.",
    "ADMIN_APPROVED_PAIR_CANCELED": "Yêu cầu hủy lệnh {{id}} đã được chấp nhận.",
    "ADMIN_REJECTED_PAIR_CANCELED": "Yêu cầu hủy lệnh {{id}} đã bị từ chối; lệnh trở về trạng thái người mua đang thanh toán. Hãy xem chi tiết.",
    "ADMIN_FORCE_CANCELED_PAIR": "Bộ phận hỗ trợ đã hủy lệnh {{orderId}}.",
    "ADMIN_FORCE_CANCELED_SELL_ORDER": "Bộ phận hỗ trợ đã hủy lệnh {{orderId}}.",
    "ADMIN_FORCE_CANCELED_BUY_ORDER": "Bộ phận hỗ trợ đã hủy lệnh {{id}}.",
    "ADMIN_FORCE_CONFIRMED": "Bộ phận hỗ trợ đã giải phóng token cho lệnh {{id}}.",
    "ADMIN_FORCE_CHANGED_AMOUNT": "Bộ phận hỗ trợ đã chỉnh sửa số tiền và giải phóng token cho lệnh {{id}}.",
    "USER_TRANSFERRED_PAYMENT_GATE_WAY": "Đã thanh toán {{amount}} {{token}}",
    "USER_RECEIVED_CURRENCY": "Đã nhận {{amount}} {{token}}",
    "USER_WITHDRAWAL_CURRENCY": "Đã rút {{amount}} USDT",
    "USER_DEPOSIT_CURRENCY": "Đã thanh toán {{amount}} {{token}}",
    "USER_EXCHANGE_IN": "Đã quy đổi {{relatedAmount}} USDT thành {{amount}} {{token}}",
    "USER_EXCHANGE_OUT": "Đã quy đổi {{mount}} {{token}} thành {{amount}} USDT",
    "USER_RECEIVED_EXCHANGE": "Đã quy đổi {{amountOut}} USDT nhận được thành {{amount}} {{token}}",
    "USER_RECEIVED_PAYOUT": "Đã nhận {{amount}} {{token}}",
    "ADMIN_BUY_ORDER_CANCELED": "Yêu cầu hủy lệnh {{orderId}} đã được chấp nhận.",
    "BUYER_BUY_ORDER_FORCE_CANCELED": "Người mua đã hủy lệnh {{subOrderId}}.",
    "ADMIN_REJECT_KYC": "Rất tiếc, xác minh của bạn không đạt. Hãy xem chi tiết trong ứng dụng.",
    "ADMIN_APPROVE_KYC": "Chúc mừng, xác minh danh tính của bạn đã đạt.",
    "BONUS_ACTIVITY_CREATED": "{{description}}"
  }
}
